__turbopack_context__.v({
  "className": "roboto_flex_fd83e35f-module__lI235G__className",
  "variable": "roboto_flex_fd83e35f-module__lI235G__variable",
});
